import {config} from '@isudio/config';
import {store, persistor, StoreHandler} from '@isudio/store';
import {setAppData, setCountries} from '@isudio/utils';
import {Logger, LogLevels} from '@isudio/utils';
import {DataService} from "@isudio/data";
import {EventHandler, SocketService, setupListeners} from "./services";
import _ from "lodash";
import Moment from 'moment';

Moment.updateLocale(config.app.language.default, config.moment.locales.default[config.app.language.default]);

export let $logger: any;
export {LogLevels};

export let $store: StoreHandler;

export const $e: EventHandler = new EventHandler();
export const $socket: SocketService = new SocketService();

store.subscribe(() => {
  if (!$store) return;
  $store.state = store.getState();
});

if (typeof window !== 'undefined') {
  window['_'] = _;
  persistor.subscribe(async () => {
    const {bootstrapped} = persistor.getState();
    if (bootstrapped) {
      $store.state = store.getState();
      $store.restoreInstances?.($store.state);
      await initApp()
    }
  });
}

export async function initApp() {
  try {
    if (_.isDebug()) {
      window.$store = $store;
      window.$e = $e;
    }

    // ✅ Initialize logger FIRST
    $logger = new Logger();

    // ✅ Setup system
    await setupListeners();
    await setupData();

    $store.App.storeReady = true;
    $e.$b($e.events.storeReady, true);

    if (_.isValidSession()) {
      $e.$b($e.events.signedIn);
    }

  } catch (err) {
    console.error("App init failed", err);
  }
}

export function setupStore() {
  $store = new StoreHandler(store);
  return {store, persistor, $store};
}

export const $data = new DataService();

export async function setupData() {
  await setCountries();
  setAppData().finally();
}

